import { IS_CLIENT, SESSION_STORAGE_PREFIX } from "@shared/constants";

export function getSessionStorageClient(prefix) {
  function setItem(key, value) {
    IS_CLIENT && sessionStorage.setItem(`${prefix}.${key}`, value);
  }

  function getItem(key) {
    return IS_CLIENT ? sessionStorage.getItem(`${prefix}.${key}`) : undefined;
  }

  function removeItem(key) {
    return IS_CLIENT
      ? sessionStorage.removeItem(`${prefix}.${key}`)
      : undefined;
  }

  return { setItem, getItem, removeItem };
}

export const sessionStorageClient = getSessionStorageClient(
  SESSION_STORAGE_PREFIX
);
